import { delay, call, select, takeEvery, takeLatest, put } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as SagaType from '../../constants/constant_saga_types';
import * as APIShiftType from '../../services/shift_type/api_shift_type';
import * as APICommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* callFetchListShiftType( feathersApp, action ) {
  try {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable( silent );

    const dataParams = { 
      filters, 
      list_type: 'shift_type'
    };
    const tableData = yield call(APICommon.getDocs, feathersApp, dataParams);
    yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (e) {
    yield SagaCommon.showErrorListTable( e );
  }
}

export function* fetchListShiftTypeSaga( feathersApp ) {
  yield takeLatest( SagaType.FETCH_LIST_SHIFT_TYPE, callFetchListShiftType, feathersApp );
}

export function* callSaveShiftType( feathersApp, action ) {
  try {
    yield SagaCommon.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const params = { tenant, user, data: action.data };
    const result = yield call( APIShiftType.saveShiftType, feathersApp, params );
    yield SagaCommon.doneSaveRecord( result, 'Shift type was saved' );
    yield put({
      type: SagasType.SIMPLE_FORM_SET_DATA,
      data: result
    });
    yield callFetchListShiftType( feathersApp, { silent: true } );
  } catch (e) {
    yield SagaCommon.showErrorSaveRecord( e );
  }
}

export function* saveShiftTypeSaga( feathersApp ) {
  yield takeEvery( SagaType.SAVE_SHIFT_TYPE, callSaveShiftType, feathersApp );
}

export function* callDeleteShiftType( feathersApp, action ) {
  try {
    yield SagaCommon.showProgressDeleteRecord();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    yield call( APIShiftType.deleteShiftType, feathersApp, params );
    yield SagaCommon.doneDeleteRecord( id, DocType.SHIFT_TYPE );
    yield delay(2000);
    yield callFetchListShiftType( feathersApp, { silent: true } );
  } catch (e) {
    yield SagaCommon.showErrorDeleteRecord( e );
  }
}

export function* deleteShiftTypeSaga( feathersApp ) {
  yield takeEvery( SagaType.DELETE_SHIFT_TYPE, callDeleteShiftType, feathersApp );
}

export function* callFetchShiftTypeById( feathersApp, action ) {
  try {
    yield SagaCommon.showProgressDataById();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    const result = yield call( APIShiftType.fetchShiftTypeById, feathersApp, params );
    yield SagaCommon.doneDataById( result );
    yield put({
      type: SagasType.SIMPLE_FORM_SET_DATA,
      data: result
    });
  } catch (e) {

  }
}

export function* fetchShiftTypeByIdSaga( feathersApp ) {
  yield takeEvery( SagaType.FETCH_SHIFT_TYPE_BY_ID, callFetchShiftTypeById, feathersApp );
}
